'use client'

import { Autocomplete, TextField } from '@mui/material'
import { CSSProperties, ChangeEvent, useState, useEffect } from 'react'

import { Option } from '../../types/option'

interface Props {
  id: string
  options: Option[]
  value?: Option | null
  defaultValue?: Option
  label?: string
  fullWidth?: boolean
  size?: 'small' | 'medium'
  style?: CSSProperties
  onChange: (newValue: Option | null) => void
  disabled?: boolean
}

export default function KanseiAutoComplete(props: Props) {
  const {
    id,
    options,
    value,
    defaultValue,
    label = '',
    fullWidth = false,
    size = 'small',
    style = {},
    onChange,
    disabled = false,
  } = props

  const [selected, setSelected] = useState<Option | null>(null)
  useEffect(() => {
    setSelected(value ?? null)
  }, [value])

  const handleOnChange = (event: ChangeEvent<any>, newValue: Option | null) => {
    setSelected(newValue)
    onChange?.(newValue)
  }

  const isOptionEqualToValue = (option: Option, value: Option | null) => {
    if (!value || !option) {
      return false
    }
    return option.value === value.value
  }

  const handleInputChange = () =>
    // _: ChangeEvent<any>,
    // _value: string,
    // reason: string,
    {
      // if (reason === 'clear' || _value === '') {
      //   onChange(null)
      // }
    }

  return (
    <Autocomplete
      disabled={disabled}
      id={id}
      options={options}
      value={selected}
      getOptionLabel={(option) => option.label}
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.label + option.value}>
            {option.label}
          </li>
        )
      }}
      renderInput={(params) => <TextField {...params} label={label} />}
      fullWidth={fullWidth}
      size={size}
      sx={style}
      noOptionsText={'該当なし'}
      onChange={handleOnChange}
      isOptionEqualToValue={isOptionEqualToValue}
      onInputChange={handleInputChange}
      defaultValue={defaultValue}
    />
  )
}
